export default __webpack_public_path__ + "static/media/53.999734c0.jpeg";